<template>
    <h1>Product</h1>
    <div>
        <p>{{name}}</p>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({

        name: 'Product',

        data: function () {
            return {
                message: 'Hello world'
            }
        },

        computed: {

        },

        methods: {

        },
        props: ['name']
    });
</script>